import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-progress-donut',
  templateUrl: './progress-donut.component.html',
  styleUrls: ['./progress-donut.component.scss'],
  standalone: false,
})
export class ProgressDonutComponent implements OnInit, OnChanges {
  @Input() progress: number = 0; // Pourcentage de progression (0-100)
  @Input() size: number = 120; // Taille du cercle en pixels
  @Input() strokeWidth: number = 8; // Épaisseur du trait
  @Input() color: string = '#75C2F6'; // Couleur de la progression
  @Input() backgroundColor: string = '#e9ecef'; // Couleur de fond
  @Input() innerFill: string = '#ffffff'; // Couleur de remplissage du centre
  @Input() showPercentage: boolean = true; // Afficher le pourcentage
  @Input() percentageColor: string = '#2C76BE'; // Couleur du texte du pourcentage
  @Input() fontSize: string = '1.2em'; // Taille de la police du pourcentage
  @Input() fontWeight: string = 'bold'; // Poids de la police
  @Input() clickable: boolean = false; // Si le composant est cliquable
  @Input() animationDuration: number = 1000; // Durée de l'animation en ms
  
  @Output() progressClick = new EventEmitter<void>(); // Événement de clic

  radius: number = 0;
  circumference: number = 0;
  strokeDasharray: string = '';
  strokeDashoffset: string = '';

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.calculateCircle();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['progress'] || changes['size'] || changes['strokeWidth']) {
      this.calculateCircle();
      this.cdr.detectChanges();
    }
  }

  // Méthode pour forcer le recalcul
  public updateProgress(newProgress: number) {
    this.progress = newProgress;
    this.calculateCircle();
    this.cdr.detectChanges();
  }

  private calculateCircle() {
    // Rayon dynamique en fonction de l'épaisseur pour garder des proportions harmonieuses
    // Le viewBox va de 0 à 100, on centre à 50
    // On laisse une marge de 2px pour éviter que le trait soit coupé
    const safeMargin = 2;
    this.radius = 50 - (this.strokeWidth / 2) - safeMargin;
    
    // Calculer la circonférence
    this.circumference = 2 * Math.PI * this.radius;
    
    // Calculer le stroke-dasharray (longueur totale du trait)
    this.strokeDasharray = `${this.circumference} ${this.circumference}`;
    
    // Calculer le stroke-dashoffset (partie masquée)
    // Pour 100%, strokeDashoffset doit être 0 (cercle complet)
    // Pour 0%, strokeDashoffset doit être égal à la circonférence (cercle vide)
    let progressOffset: number;
    if (this.progress >= 100) {
      progressOffset = 0; // Cercle complètement fermé
    } else {
      progressOffset = this.circumference - (this.progress / 100) * this.circumference;
    }
    this.strokeDashoffset = progressOffset.toString();
      }

  

  onProgressClick() {
    if (this.clickable) {
      this.progressClick.emit();
    }
  }

  getCircleStyle() {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
    };
  }

  getBackgroundCircleStyle() {
    return {
      stroke: this.backgroundColor,
      strokeWidth: this.strokeWidth,
    };
  }

  getProgressCircleStyle() {
    return {
      strokeWidth: this.strokeWidth,
      strokeDasharray: this.strokeDasharray,
      strokeDashoffset: this.strokeDashoffset,
      transition: `stroke-dashoffset ${this.animationDuration}ms ease-in-out`,
    };
  }

  getPercentageStyle() {
    return {
      color: this.percentageColor,
      fontSize: this.fontSize,
      fontWeight: this.fontWeight,
    };
  }

  getCursorStyle() {
    return {
      cursor: this.clickable ? 'pointer' : 'default',
    };
  }

  // Propriété Math pour le template
  get Math() {
    return Math;
  }
}
